import _ from 'lodash'

import { POC_MNG } from '@/api/apiModules'
import lang from '@/lang'
export default {
  viewType: 'form',
  module: POC_MNG,
  needFetchFillInfo: false,
  params: null,
  formatData(data) {
    data.salesId = data.salesIdLabel.id
    data.presalesId = data.presalesIdLabel.id
    data.postsalesId = data.postsalesIdLabel.id

    if (data.envRelateSceneArr) {
      data.envRelateSceneList = data.envRelateSceneArr.map(item => {
        return {
          collectReportId: item.envData.id,
          sceneId: item.scene
        }
      })
    }

    return data
  },
  view: {
    title: 'pocMng.createBasePocProject',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '650px',
    content: [
      {
        $id: 'industryId',
        $type: 'radio-button',
        label: 'pocMng.industry',
        $default: null,
        params: {
          unPage: true
        },
        $el: {
          class: 'wsp-custom-edit-industry-disabled',
          disabled: true
        },
        $options: 'projectInfo/industry/list',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.industryName
            }
          })
          if (!value) {
            value = meta.$options[0].value
          }

          return value
        },
        rules: [
          {
            notEmpty: 'pocMng.industryEmpty'
          }
        ]
      },
      {
        $id: 'customer',
        $type: 'input',
        label: 'pocMng.customer',
        rules: [
          {
            notEmpty: 'pocMng.customer'
          }
        ]
      },
      {
        $id: 'salesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.sales',
        $el: { disabled: false, multiple: false },

        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.salesEmpty' } }]
      },
      {
        $id: 'presalesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.presales',
        $el: { disabled: false },
        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.presalesEmpty' } }]
      },
      {
        $id: 'postsalesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.postsales',
        $el: { disabled: false },
        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesEmpty' } }]
      },
      {
        $id: 'projectType',
        $type: 'select',
        label: 'pocMng.projectType',
        $default: 'OPPORTUNITY',
        $el: {
          filterable: true,
          multiple: false
        },
        $options: [
          {
            label: '机会',
            id: 'OPPORTUNITY'
          },
          {
            label: '可能-',
            id: 'POSSIBLE_MINUS'
          },
          {
            label: '可能+',
            id: 'POSSIBLE_PLUS'
          },
          {
            label: '确保',
            id: 'ENSURE'
          },
          {
            label: '优势',
            id: 'ADVANTAGE'
          }
        ],
        rules: [
          {
            notEmpty: 'pocMng.projectTypeEmpty'
          }
        ]
      },
      {
        $id: 'projectBackground',
        $type: 'input',
        label: 'pocMng.projectBackground',
        $el: {
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'pocMng.projectBackground'
          }
        ]
      },
      {
        $id: 'projectRequest',
        $type: 'input',
        label: 'pocMng.projectRequest',
        tip: {
          description: ['pocMng.tips.projectRequest']
        },
        $el: {
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'pocMng.projectRequest'
          }
        ]
      },
      {
        $id: 'startTime',
        $type: 'datePicker',
        $el: {
          type: 'date'
        },
        label: 'pocMng.startTime',
        rules: [
          {
            notEmpty: 'pocMng.startTimeEmpty'
          }
        ]
      },
      {
        $id: 'projectCycle',
        $type: 'input-number',
        $el: {
          min: 0
        },
        label: 'pocMng.testCycle',
        rules: [
          {
            notEmpty: 'pocMng.testCycleEmpty'
          }
        ]
      },
      {
        $id: 'testModeArr',
        $type: 'select',
        label: 'pocMng.testMode',
        $default: [],
        $el: {
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: '功能测试',
            id: 'FUNCTION_TEST'
          },
          {
            label: '性能测试',
            id: 'PERFORMANCE_TEST'
          },
          {
            label: '体验测试',
            id: 'EXPERIENCE_TEST'
          }
        ],
        rules: [
          {
            notEmpty: 'pocMng.testModeEmpty'
          }
        ]
      },
      {
        $id: 'competitorArr',
        $type: 'select',
        label: 'pocMng.competitor',
        $default: [],
        $el: {
          filterable: true,
          multiple: true
        },
        $options: [
          {
            value: 'HUAWEI',
            label: '华为'
          },
          {
            value: 'SANGFOR',
            label: '深信服'
          },
          {
            value: 'H3C',
            label: 'H3C'
          },
          {
            value: 'OS_EASY',
            label: '噢易'
          },
          {
            value: 'KD_MASTER',
            label: '铠大师'
          },
          {
            value: 'CAI_HONG',
            label: '彩虹'
          },
          {
            value: 'SKY_WORTH',
            label: '创维'
          }
        ],
        rules: []
      },
      {
        $id: 'otherCompetitors',
        $type: 'input',
        label: 'pocMng.otherCompetitor',
        $el: {
          placeholder: lang.t('pocMng.otherCompetitorPlaceholder')
        }
      }
    ]
  }
}
